export const ThemeTypes = {
  dark: 'dark',
  light: 'light',
  auto: 'auto',
} as const;
export type ThemeTypes = (typeof ThemeTypes)[keyof typeof ThemeTypes];
